import { render, staticRenderFns } from "./ProntoSocorroComponente.vue?vue&type=template&id=2e37e1d6"
import script from "./ProntoSocorroComponente.vue?vue&type=script&lang=js"
export * from "./ProntoSocorroComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports